var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1413,
    height: 880,
    viewBox: "0 0 1413 880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.34,
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1242.389,
    cy: 663.853,
    r: 4,
    fill: "#8DB2BF",
    opacity: 0.77,
    transform: "rotate(-88 1242.389 663.853)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1247.879,
    cy: 445.179,
    r: 3.5,
    fill: "#8DB2BF",
    opacity: 0.73,
    transform: "rotate(-155 1247.879 445.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1345.751,
    cy: 306.547,
    r: 3.5,
    fill: "#8DB2BF",
    opacity: 0.81,
    transform: "rotate(70 1345.75 306.547)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1349.557,
    cy: 40.858,
    r: 4.5,
    fill: "#8DB2BF",
    opacity: 0.73,
    transform: "rotate(84 1349.557 40.858)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.447,
    cy: 6.946,
    r: 3.5,
    fill: "#8DB2BF",
    opacity: 0.7,
    transform: "rotate(-131 1143.447 6.946)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 984.237,
    cy: 528.203,
    r: 4.5,
    fill: "#8DB2BF",
    opacity: 0.71,
    transform: "rotate(-35 984.237 528.203)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.671,
    cy: 682.21,
    r: 3.5,
    fill: "#8DB2BF",
    opacity: 0.78,
    transform: "rotate(-147 230.671 682.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.279,
    cy: 317.979,
    r: 4,
    fill: "#8DB2BF",
    opacity: 0.94,
    transform: "rotate(76 333.28 317.979)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.86,
    cy: 536.429,
    r: 4,
    fill: "#8DB2BF",
    opacity: 0.82,
    transform: "rotate(87 49.86 536.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.484,
    cy: 170.878,
    r: 4.5,
    fill: "#8DB2BF",
    opacity: 0.7,
    transform: "rotate(171 5.484 170.878)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M1396.696 833.021a1 1 0 0 0-.766.643l-3.144 8.636a1 1 0 0 0 .174.985l5.907 7.04a1 1 0 0 0 .94.343l9.051-1.596a1 1 0 0 0 .766-.643l3.144-8.637a1 1 0 0 0-.174-.984l-5.908-7.04a1 1 0 0 0-.94-.343l-9.05 1.596z",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M1373.94 523.425a1 1 0 0 0-.14.99l2.694 6.667a1 1 0 0 0 .788.616l7.12 1a1 1 0 0 0 .927-.374l4.427-5.667a1 1 0 0 0 .14-.99l-2.694-6.667a1 1 0 0 0-.788-.616l-7.12-1a1 1 0 0 0-.928.374l-4.427 5.667z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M1138.324 796.943a1 1 0 0 0 .47.883l4.825 3.016a1 1 0 0 0 1 .034l5.024-2.671a1 1 0 0 0 .53-.848l.198-5.687a1 1 0 0 0-.469-.883l-4.826-3.016a1 1 0 0 0-1-.035l-5.024 2.672a1 1 0 0 0-.53.848l-.198 5.687z",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M1067.076 532.519a1 1 0 0 0-.5.866v7.69a1 1 0 0 0 .5.867l6.66 3.845a1 1 0 0 0 1 0l6.66-3.845a1 1 0 0 0 .5-.866v-7.691a1 1 0 0 0-.5-.866l-6.66-3.845a1 1 0 0 0-1 0l-6.66 3.845z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M856.168 746.015a1 1 0 0 0 .053-.998l-2.81-5.516a1 1 0 0 0-.84-.545l-6.181-.324a1 1 0 0 0-.891.454l-3.372 5.192a1 1 0 0 0-.052.999l2.81 5.515a1 1 0 0 0 .839.545l6.182.324a1 1 0 0 0 .89-.454l3.372-5.192z",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M875.698 224.593a1 1 0 0 0 .914.407l4.665-.49a1 1 0 0 0 .809-.589l1.907-4.285a1 1 0 0 0-.104-.994l-2.757-3.795a1 1 0 0 0-.914-.407l-4.665.49a1 1 0 0 0-.809.588l-1.908 4.286a1 1 0 0 0 .105.994l2.757 3.795z",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M798.228 19.587a1 1 0 0 0 .208.978l3.138 3.486a1 1 0 0 0 .952.309l4.588-.975a1 1 0 0 0 .743-.67l1.45-4.46a1 1 0 0 0-.209-.979l-3.138-3.486a1 1 0 0 0-.951-.309l-4.588.976a1 1 0 0 0-.744.669l-1.45 4.46zM481.44 279.474a1 1 0 0 0-.732.682l-2.687 8.79a1 1 0 0 0 .225.974l6.268 6.721a1 1 0 0 0 .956.293l8.955-2.068a1 1 0 0 0 .732-.682l2.687-8.789a1 1 0 0 0-.225-.974l-6.268-6.722a1 1 0 0 0-.956-.292l-8.955 2.067z",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M584.75 195.756a1 1 0 0 0 .848.53l4.688.163a1 1 0 0 0 .883-.47l2.485-3.977a1 1 0 0 0 .035-1l-2.202-4.141a1 1 0 0 0-.848-.53l-4.688-.164a1 1 0 0 0-.883.47l-2.485 3.978a1 1 0 0 0-.035.999l2.202 4.142z",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M469.138 111.47a1 1 0 0 0 .707-.707l1.214-4.531a1 1 0 0 0-.258-.966l-3.317-3.317a1 1 0 0 0-.966-.259l-4.53 1.214a1 1 0 0 0-.708.707l-1.214 4.531a1 1 0 0 0 .259.966l3.317 3.317a1 1 0 0 0 .966.259l4.53-1.214z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M227.43 874.61a1 1 0 0 0 .017 1l2.416 4.02a1 1 0 0 0 .875.485l4.69-.082a1 1 0 0 0 .857-.515l2.274-4.102a1 1 0 0 0-.017-1l-2.416-4.021a1 1 0 0 0-.875-.485l-4.69.082a1 1 0 0 0-.857.515l-2.274 4.103z",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M364.554 522.627a1 1 0 0 0-.515-.858l-6.726-3.728a1 1 0 0 0-1 .017l-6.592 3.961a1 1 0 0 0-.485.875l.134 7.69a1 1 0 0 0 .515.857l6.727 3.728a1 1 0 0 0 1-.017l6.592-3.961a1 1 0 0 0 .484-.875l-.134-7.69z",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M272.026 221.995a1 1 0 0 0 .342-.94l-1.248-7.081a1 1 0 0 0-.643-.766l-6.757-2.46a1 1 0 0 0-.985.174l-5.508 4.622a1 1 0 0 0-.342.94l1.249 7.081a1 1 0 0 0 .642.766l6.757 2.46a1 1 0 0 0 .985-.174l5.508-4.622z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M209.59 41.361a1 1 0 0 0-.788.616l-1.945 4.812a1 1 0 0 0 .14.99l3.195 4.09a1 1 0 0 0 .927.375l5.14-.722a1 1 0 0 0 .788-.616l1.945-4.812a1 1 0 0 0-.14-.99l-3.195-4.09a1 1 0 0 0-.927-.375l-5.14.722z",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81849A",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    d: "M174.803 729.924a1 1 0 0 0 .407.913l5.817 4.227a1 1 0 0 0 .995.104l6.568-2.924a1 1 0 0 0 .588-.81l.752-7.15a1 1 0 0 0-.407-.914l-5.817-4.227a1 1 0 0 0-.995-.104l-6.569 2.925a1 1 0 0 0-.587.809l-.752 7.15z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1338.071,
    cy: 192.102,
    r: 4,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.79,
    transform: "rotate(53 1338.071 192.102)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1110.091,
    cy: 652.279,
    r: 6,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.96,
    transform: "rotate(126 1110.09 652.279)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.091,
    cy: 672.279,
    r: 6,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.96,
    transform: "rotate(126 450.09 672.279)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.642,
    cy: 413.299,
    r: 6,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.84,
    transform: "rotate(68 1182.642 413.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844.769,
    cy: 650.968,
    r: 4.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.77,
    transform: "rotate(-92 844.769 650.968)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.137,
    cy: 212.857,
    r: 6,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.87,
    transform: "rotate(141 1206.137 212.857)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 968.018,
    cy: 343.296,
    r: 4,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.42,
    transform: "rotate(-31 968.018 343.296)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 847.111,
    cy: 97.82,
    r: 5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.73,
    transform: "rotate(-37 847.11 97.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 655.45,
    cy: 808.874,
    r: 3.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.89,
    transform: "rotate(57 655.45 808.874)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.955,
    cy: 874.859,
    r: 5.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.97,
    transform: "rotate(-29 423.955 874.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.003,
    cy: 441.973,
    r: 3.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.88,
    transform: "rotate(48 354.003 441.973)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.298,
    cy: 859.471,
    r: 4,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.74,
    transform: "rotate(81 99.298 859.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.825,
    cy: 462.08,
    r: 6.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.81,
    transform: "rotate(-139 138.825 462.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.615,
    cy: 296.465,
    r: 6.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.71,
    transform: "rotate(138 118.615 296.465)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.989,
    cy: 8.328,
    r: 4.5,
    stroke: "#007A84",
    strokeWidth: 3,
    opacity: 0.9,
    transform: "rotate(-149 19.989 8.328)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.4c18d6d9200fa24c123569c2499accd8.svg";
export { ForwardRef as ReactComponent };